export default __webpack_public_path__ + "static/media/7-sgi-matricula-v2.62eca8f8.png";